import React, { useState, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CustomRule,
  EmailRule
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import LoadIndicator from 'devextreme-react/load-indicator';
import { createAccount } from '../../api/auth';

import './CreateAccountForm.scss';
import axios from 'axios';
import GlobalParams from '../../helpers/GlobalParams';
import { Popup } from 'devextreme-react';
import TermsOfService from '../../pages/TermsOfService/TermsOfService';

export default function CreateAccountForm() {
  const navigate = useNavigate();
  const [tosComponent, setToSComponent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [popupToSVisible, setPopupToSVisible] = useState(false);
  const [isValidBtn, setIsValidBtn] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const formData = useRef({ policy_no: '', email: '', password: '', confirm_password: '', otp: '', acceptTermsServices: false });

  
  const hideToSPopup = () => {
    setPopupToSVisible(false);
  }
  
  ////validate policy/////
  const onValidatePolicy = async (policyno, email, acceptTermsServices) => {
    try {
      //if (acceptTermsServices) {
        // Send request using axios
        const response = await axios.post(
          GlobalParams.LoginApiUrlPrefixV2 + 'send-otp-for-password-creation',
          {
            policy_no: policyno,
            contact_person_email: email,
          },
          {
            headers: {
              Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
            }
          }
        );

        if (response.status === 200 || response.status === 201) {
          //console.log(response);
          //console.log(response.data.data.contact_email);
          let return_email = response.data.data.contact_email;
          //formData.current.email = response.data.data.email;
          formData.current = { ...formData.current, email: return_email };
          //service.setClientStore(response.data.data);
          setIsValidBtn(false);
          setIsValid(true);
          setLoading(false);
          notify("Successfully Validated and OTP sent to: " + return_email, 'success', 10000);
        }
      // }else{
      //   notify("Accept the Terms of Service first in order to proceed.", 'error', 5000);
      // }

    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  const onSignUp = async (email, password, otp) => {
    try {
      // Send request using axios
      const response = await axios.post(
        GlobalParams.LoginApiUrlPrefixV2 + 'create-cp-password',
        {
          email: email,
          otp: otp,
          password: password,
          confirm_password: password
        },
        {
          headers: {
            Authorization: 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        setLoading(false);
        if (response.data.success) {
          notify({
            message: 'Registration successful! You may proceed to login.',
            type: 'success',
            displayTime: 5000,
            position: { at: 'bottom center', my: 'bottom center' },
          });
          navigate('/login');
        } else {
          notify(response.data.message, 'error', 5000);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  }

  ////register the account////

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { email, password, otp } = formData.current;
    setLoading(true);

    onSignUp(email, password, otp);
    //const result = await createAccount(email, password, otp);

  }, [navigate]);

  const confirmPassword = useCallback(
    ({ value }) => value === formData.current.password,
    []
  );

  return (
    <div>
      <div>
        <Popup
          visible={popupToSVisible}
          onHiding={hideToSPopup}
          title="TERMS OF SERVICE"

        >
          <TermsOfService onClosePopup={() => {           
            //set value to true
            tosComponent.component.option('value', true);
            formData.current.acceptTermsServices = true;
            hideToSPopup();
          }} />
        </Popup>
      </div>
    <form className={'create-account-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={'policy_no'}
          editorType={'dxTextBox'}
          editorOptions={
            {
              stylingMode: 'filled',
              placeholder: 'Policy Number',
              //readOnly: isValid
            }
          }
        >
          <RequiredRule message="Policy No is required" />
          <Label visible={false} />
        </Item>

        <Item
          dataField={'contact_person_email'}
          editorType={'dxTextBox'}
          editorOptions={
            {
              stylingMode: 'filled',
              placeholder: 'Contact Person Email',
              //readOnly: isValid
            }
          }
        >
          <RequiredRule message="Contact Person Email is required" />
          <EmailRule message="Email is invalid" />
          <Label visible={false} />
        </Item>

        {/* <Item
          colSpan={3}
          dataField="acceptTermsServices"
          editorType="dxCheckBox"
          editorOptions={
            {
              onValueChanged: (e) => {
                if (e.value === true) {
                  e.component.option('value', false);
                  setToSComponent(e);
                  setPopupToSVisible(true);
                }
              }
            }
          }
        >
          <Label text='Accept the Terms of Service' />
        </Item> */}

        <ButtonItem>
          <ButtonOptions
            width={'50%'}
            type={'default'}
            onClick={
              () => {
                //if(formData.current.acceptTermsServices === false){
                  //notify("Accept the Terms of Service first in order to proceed.", 'error', 5000);                
                //}else{
                  setLoading(true);
                  onValidatePolicy(formData.current.policy_no, formData.current.contact_person_email, formData.current.acceptTermsServices);
               // }
              }
            }
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Validate'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>

        <Item
          dataField={'email'}
          editorType={'dxTextBox'}
          visible={isValid}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="Email is required" />
          <EmailRule message="Email is invalid" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          visible={isValid}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <CustomRule
            message="Password must have at least 10 characters, one capital letter, one number, 
            and one special character"
            validationCallback={(e) => {
              const password = e.value;
              const isValidLength = password.length >= 10;
              const hasCapitalLetter = /[A-Z]/.test(password);
              const hasNumber = /\d/.test(password);
              const hasSpecialCharacter = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
              return isValidLength && hasCapitalLetter && hasNumber && hasSpecialCharacter;
            }}
          />
          <Label visible={false} />
        </Item>

        <Item
          dataField={'confirm_password'}
          editorType={'dxTextBox'}
          visible={isValid}
          editorOptions={confirmedPasswordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <CustomRule
            message={'Passwords do not match'}
            validationCallback={confirmPassword}
          />
          <Label visible={false} />
        </Item>

        <Item
          dataField={'otp'}
          editorType={'dxTextBox'}
          visible={isValid}
          editorOptions={otpEditorOptions}
        >
          <RequiredRule message="OTP is required" />
          <Label visible={false} />
        </Item>


        <Item>
          <div className='policy-info'>
            By creating an account, you agree to the <Link to="#">Terms of Service</Link> and <Link to="#">Privacy Policy</Link>
          </div>
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            visible={isValid}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Create a new account'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={'login-link'}>
            Have an account? <Link to={'/login'}>Sign In</Link>
          </div>
        </Item>
      </Form>
    </form>
    </div>
  );
}
//otpEditorOptions readOnly: this.isValid 

const otpEditorOptions = { stylingMode: 'filled', placeholder: 'OTP' };
const policynoEditorOptions = { stylingMode: 'filled', placeholder: 'Policy Number' };
const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email', readOnly: false };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };
const confirmedPasswordEditorOptions = { stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' };
